// extracted by mini-css-extract-plugin
module.exports = {"Divider":"📚4-7-0E72ZA"};